class CustomSelect {
  constructor(selector) {
      this.customSelects = document.getElementsByClassName(selector);
      this.init();
  }

  init() {
      const l = this.customSelects.length;
      for (let i = 0; i < l; i++) {
          const selElmnt = this.customSelects[i].getElementsByTagName("select")[0];
          const ll = selElmnt.length;
          
          // Create a new DIV that will act as the selected item:
          const a = document.createElement("DIV");
          a.setAttribute("class", "select-selected");
          a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
          this.customSelects[i].appendChild(a);

          // Create a new DIV that will contain the option list:
          const b = document.createElement("DIV");
          b.setAttribute("class", "select-items select-hide");

          for (let j = 1; j < ll; j++) {
              // Create a new DIV for each option:
              const c = document.createElement("DIV");
              c.innerHTML = selElmnt.options[j].innerHTML;
              c.addEventListener("click", (e) => this.optionClick(e, selElmnt, a));
              b.appendChild(c);
          }

          this.customSelects[i].appendChild(b);

          // Add click event to the currently selected item:
          a.addEventListener("click", (e) => this.toggleSelect(e, a, b));
      }

      // Close all select boxes if clicked outside:
      document.addEventListener("click", (e) => this.closeAllSelect(e));
  }

  // Method to handle option click
  optionClick(e, selectElmnt, selectedDiv) {
      const optionDivs = e.target.parentNode.getElementsByClassName("same-as-selected");
      const sl = selectElmnt.length;
      const h = selectedDiv;
      
      // Update the original select box and the selected item
      for (let i = 0; i < sl; i++) {
          if (selectElmnt.options[i].innerHTML === e.target.innerHTML) {
              selectElmnt.selectedIndex = i;
              h.innerHTML = e.target.innerHTML;
              
              // Remove the class from previously selected options
              for (let k = 0; k < optionDivs.length; k++) {
                  optionDivs[k].classList.remove("same-as-selected");
              }
              e.target.classList.add("same-as-selected");
              
              // Trigger the change event on the original select element
              const event = new Event('change', { bubbles: true });
              selectElmnt.dispatchEvent(event);
              
              break;
          }
      }
      h.click(); // Close the dropdown
  }

  // Method to handle dropdown toggle
  toggleSelect(e, selectedDiv, optionsDiv) {
      e.stopPropagation();
      this.closeAllSelect(selectedDiv);
      optionsDiv.classList.toggle("select-hide");
      selectedDiv.classList.toggle("select-arrow-active");
  }

  // Method to close all select boxes except the current one
  closeAllSelect(elmnt) {
      const items = document.getElementsByClassName("select-items");
      const selectedItems = document.getElementsByClassName("select-selected");
      const arrNo = [];
      
      // Close all select items and selected items except the current one
      for (let i = 0; i < selectedItems.length; i++) {
          if (elmnt === selectedItems[i]) {
              arrNo.push(i);
          } else {
              selectedItems[i].classList.remove("select-arrow-active");
          }
      }
      for (let i = 0; i < items.length; i++) {
          if (arrNo.indexOf(i) === -1) {
              items[i].classList.add("select-hide");
          }
      }
  }
}

export default CustomSelect;
